import $ from "jquery";

import { setupMap } from "../maps_common";

function setup() {
  if ($("body.attractions.show").length == 0) return; //make it page specific
  let map;

  const thisPageSlug = $('link[rel="canonical"]')
    .attr("href")
    .split("/")
    .slice(-1)[0];

  if (isiOS) {
    //prevent pull to refresh on IOS Workaround as Ios doenst support overscroll css yet
    document.getElementById("map-modal").addEventListener("touchmove", (e) => {
      e.preventDefault();
    });
  }

  $("#map-modal").iziModal({
    openFullscreen: true,
    // autoOpen: window.location.hash.substr(1) === "map-modal",
    autoOpen: false,
    history: false,
    onResize: () => {
      $(".modal-content").css("height", $(window).innerHeight()); //set 100% height
    },
    onOpened: () => {
      fixBackgroundScroll();

      if (map) return;
      map = setupMap("map-modal-body");
    },
    onOpening: () => {
      if ("gtag" in window) {
        gtag("event", "open", {
          event_category: "Map",
          event_label: `show ${document.location}`,
        });
      }
    },
    onClosing: function () {
      unFixBackgroundScroll();
    },
  });

  $("#attraction-submission-modal").iziModal({
    onOpened: () => {
      fixBackgroundScroll();
    },
    onClosing: function () {
      unFixBackgroundScroll();
    },
    history: false,
    openFullscreen: isMobileOrTablet,
  });

  // Toto som du dal aby sa mi lahsie davali popisy ako Adminovi ked uploadnem fotky cez plugin aby nebolo treba chodit do editu ale dalo sa to upravit rovno zo showu..
  $("#thumbnail-row .thumbnail[data-editable]").on("contextmenu", (e) => {
    event.preventDefault();

    const currentTitle = $(e.currentTarget).data("title");
    const photoId = $(e.currentTarget).data("photo-id");

    bootbox.prompt({
      title: I18n.t("js.attractions.enter_description"),
      value: I18n.t("js.attractions.prefilled_photo_description"),
      callback: (newTitle) => {
        if (newTitle === null) return;

        $.ajax({
          type: "PUT",
          url: `/${I18n.defaultLocale}/admin/photos/${photoId}/update_title`,
          data: JSON.stringify({ title: newTitle }),
          contentType: "application/json", // Overwrite the default content type: application/x-www-form-urlencoded
          success: function (data) {
            $(e.currentTarget).data("title", newTitle);
            $(e.currentTarget).fadeOut(100).fadeIn(100);
          },
        });
      },
    });
  });

  //toto este patri k popisom foto abysom mohol lahko prepinat wiki a nie wiki
  $("body.attractions.show").on("keydown", "input.bootbox-input", (e) => {
    if (e.key === "F1") {
      if (
        e.currentTarget.value ==
        I18n.t("js.attractions.prefilled_photo_description")
      )
        e.currentTarget.value = I18n.t(
          "js.attractions.alternative_prefilled_photo_description"
        );
      else
        e.currentTarget.value = I18n.t(
          "js.attractions.prefilled_photo_description"
        );
    }
  });

  let currentPhoto = 0;
  const photos = $("#thumbnail-row .thumbnail").toArray();

  function showNextPhoto() {
    currentPhoto += 1;
    currentPhoto = currentPhoto % photos.length;
    switchToPhoto(currentPhoto);
  }

  document.getElementById("main-photo-wrapper").addEventListener(
    "scroll",
    function (e) {
      currentPhoto = Math.round(
        $(e.currentTarget).scrollLeft() / $("#main-photo-wrapper").width()
      );
      $("#thumbnail-row .thumbnail").removeClass("selected");
      $(photos[currentPhoto]).addClass("selected");
    },
    {
      passive: true,
    }
  );

  function switchToPhoto(photo) {
    const nextPos = photo * $("#main-photo-wrapper").width();
    $("#main-photo-wrapper").scrollLeft(nextPos);
  }

  function showPreviousPhoto() {
    currentPhoto -= 1;
    currentPhoto =
      ((currentPhoto % photos.length) + photos.length) % photos.length; //JS negative modulo fix
    switchToPhoto(currentPhoto);
  }

  $("#next-photo-btn").on("click tap", () => {
    showNextPhoto();
  });
  $("#previous-photo-btn").on("click tap", () => {
    showPreviousPhoto();
  });
  $("#main-photo-wrapper").on("click tap", () => {
    photos[currentPhoto].click();
  });

  if (isMobileOrTablet) {
    $("#main-photo-wrapper,#thumbnail-row").on("click tap", function (e) {
      $("#mobile-gallery").css({ display: "block" });

      const photoId = $(e.target).data("photo-id");
      const scrollTo =
        document.getElementById(`mobile-gallery-photo-${photoId}`).offsetTop -
        70;

      if (photoId) {
        document
          .getElementById("mobile-gallery")
          .scrollTo({ top: Math.max(0, scrollTo), behaviour: "smooth" });
      }
    });
  }

  lightbox.init();

  // we load weather dynamically so the rest of the page may be action cached
  jQuery.get($("#weather-container").data("url"), (weatherHtml) => {
    $("#weather-container").html(weatherHtml);
  });

  FAVOURITES.markShowPage(thisPageSlug); //turn on favlink if this page is favourited

  $(".show-toolbox .favourite-attraction").on("click", (e) => {
    FAVOURITES.toggle(thisPageSlug);
    FAVOURITES.markShowPage(thisPageSlug);
  });

  $(".show-toolbox .scroll-to-comments").on("click", (e) => {
    window.scrollTo({
      top: $("#comments-title").offset().top - 50,
      behavior: "smooth",
    });
  });

  if ($("#scrape-ai-link").length) {
    $("#scrape-ai-link").on("ajax:send", (e) => {
      $("#scrape-ai-loader").show();
    });
    $("#scrape-ai-link").on("ajax:complete", (e) => {
      $("#scrape-ai-loader").hide();
    });
  }

  if ($("#allowed_web_check_exceptions_select").length) {
    $("#allowed_web_check_exceptions_select").select2({ width: "70%" });
    $("#allowed_web_check_exceptions_select").on("change", function (e) {
      const selectedValues = $(this).val();

      $.ajax({
        type: "PUT",
        url: `/${I18n.defaultLocale}/admin/attractions/${$(this).data(
          "attraction-id"
        )}/update_allowed_web_check_exceptions`,
        data: JSON.stringify({
          allowed_web_check_exceptions: selectedValues,
        }),
        contentType: "application/json", // Overwrite the default content type: application/x-www-form-urlencoded
        error: function (data) {
          $(".select2-container .select2-selection:visible").css(
            "border-color",
            "red"
          );
        },
      });

      console.log(
        "Selected values:",
        $(this).data("attraction-id"),
        selectedValues
      );
    });
  }
} //setup

function teardown() {
  if ($("body.attractions.show").length == 0) return; //make it page specific

  $("#emailValue").children("a").remove(); //email is obfuscated by javascript but when we go back, its rebuilded again so without removing it would be duplicit there

  $("#lightbox").remove();
  $("#lightboxOverlay").remove();
  $("#map-modal-body").empty();
  $("#map-modal").iziModal("destroy");
  unFixBackgroundScroll();

  $("#allowed_web_check_exceptions_select").off("change");
} //teardown

$(document).on("DOMContentLoaded", setup); //turbolinks:load
//$(document).on("turbolinks:before-cache", teardown);
